import React from 'react'
import { AppBar, makeStyles, Container, Toolbar } from '@material-ui/core'

const useHeaderStyles = makeStyles(() => ({
    appBar: ({ bgColor }) => ({
        backgroundColor: bgColor,
    }),
    xlContainer: {
        padding: 0,
        display: 'flex', // for IE
        flexDirection: 'column',
    },
    toolbar: ({ height }) => ({
        //alignItems: 'stretch',
        width: '100%',
        flexDirection: 'column',
        padding: '8px 14px',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        minHeight: height,
    }),
}))

const MobileHeader = ({ children, bgColor, height }) => {
    const headerStyles = useHeaderStyles({ bgColor, height })
    return (
        <AppBar className={headerStyles.appBar}>
            <Container maxWidth="xl" className={headerStyles.xlContainer}>
                <Toolbar disableGutters className={headerStyles.toolbar}>
                    {children}
                </Toolbar>
            </Container>
        </AppBar>
    )
}

MobileHeader.defaultProps = {
    bgColor: '#fff',
}

export default MobileHeader
